import * as i0 from '@angular/core';
import { Directive, Component, ViewChild, Input, EventEmitter, ContentChildren, Output, NgModule, HostListener, TemplateRef, ContentChild } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@angular/material/expansion';
import { MatAccordion, MAT_EXPANSION_PANEL_DEFAULT_OPTIONS, MatExpansionModule } from '@angular/material/expansion';
import * as i6 from '@gsa-sam/ngx-uswds-icons';
import { IconModule } from '@gsa-sam/ngx-uswds-icons';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i2$1 from '@angular/material/sort';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { BehaviorSubject } from 'rxjs';
import * as i3 from '@angular/material/table';
import { MatTableDataSource, MatTable, MatTableModule } from '@angular/material/table';
import * as i4 from '@angular/material/paginator';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import * as i5 from '@gsa-sam/components';
import { PaginationModule } from '@gsa-sam/components';
import * as i1$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i1$2 from 'ngx-bootstrap-icons';
import { NgxBootstrapIconsModule, chevronUp, chevronDown } from 'ngx-bootstrap-icons';
import * as i2$2 from '@angular/material/button-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

const _c0$2 = ["itemTitleTemplate"];
const _c1$2 = ["itemContentTemplate"];
const _c2$2 = [[["sds-accordion-title"]], [["sds-accordion-content"]]];
const _c3$2 = ["sds-accordion-title", "sds-accordion-content"];
function SdsAccordionItemComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["#title", ""]);
} }
function SdsAccordionItemComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 1, ["#content", ""]);
} }
const _c4$1 = a0 => ({ "sds-expansion-indicator--expanded": a0 });
const _c5$1 = a0 => ({ "display-none": a0 });
function SdsAccordionComponent_ng_container_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SdsAccordionComponent_ng_container_1_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SdsAccordionComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-expansion-panel", 2);
    i0.ɵɵtwoWayListener("expandedChange", function SdsAccordionComponent_ng_container_1_Template_mat_expansion_panel_expandedChange_1_listener($event) { const accordionItem_r2 = i0.ɵɵrestoreView(_r1).$implicit; i0.ɵɵtwoWayBindingSet(accordionItem_r2.expanded, $event) || (accordionItem_r2.expanded = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementStart(2, "mat-expansion-panel-header", 3)(3, "mat-panel-title");
    i0.ɵɵelement(4, "span", 4);
    i0.ɵɵtemplate(5, SdsAccordionComponent_ng_container_1_ng_container_5_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "span", 6);
    i0.ɵɵtemplate(7, SdsAccordionComponent_ng_container_1_ng_container_7_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const accordionItem_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("expanded", accordionItem_r2.expanded);
    i0.ɵɵproperty("disabled", accordionItem_r2.disabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("collapsedHeight", ctx_r2.collapsedHeight)("expandedHeight", ctx_r2.expandedHeight);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c4$1, accordionItem_r2.expanded));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", accordionItem_r2.itemTitleTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c5$1, !accordionItem_r2.expanded));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", accordionItem_r2.itemContentTemplate);
} }
class SdsAccordionTitleDirective {
    /** @nocollapse */ static { this.ɵfac = function SdsAccordionTitleDirective_Factory(t) { return new (t || SdsAccordionTitleDirective)(); }; }
    /** @nocollapse */ static { this.ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: SdsAccordionTitleDirective, selectors: [["sds-accordion-title"]] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsAccordionTitleDirective, [{
        type: Directive,
        args: [{ selector: 'sds-accordion-title' }]
    }], null, null); })();
class SdsAccordionContentDirective {
    /** @nocollapse */ static { this.ɵfac = function SdsAccordionContentDirective_Factory(t) { return new (t || SdsAccordionContentDirective)(); }; }
    /** @nocollapse */ static { this.ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: SdsAccordionContentDirective, selectors: [["sds-accordion-content"]] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsAccordionContentDirective, [{
        type: Directive,
        args: [{ selector: 'sds-accordion-content' }]
    }], null, null); })();
class SdsAccordionItemComponent {
    constructor() {
        this.expanded = false;
        this.disabled = false;
    }
    /** Toggles the expanded state of the expansion panel. */
    toggle() {
        this.expanded = !this.expanded;
    }
    /** Sets the expanded state of the expansion panel to false. */
    close() {
        this.expanded = false;
    }
    /** Sets the expanded state of the expansion panel to true. */
    open() {
        this.expanded = true;
    }
    /** Toggles the disabled state of the expansion panel. */
    toggleDisabled() {
        this.disabled = !this.disabled;
        if (this.disabled) {
            this.expanded = false;
        }
    }
    /** @nocollapse */ static { this.ɵfac = function SdsAccordionItemComponent_Factory(t) { return new (t || SdsAccordionItemComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: SdsAccordionItemComponent, selectors: [["sds-accordion-item"]], viewQuery: function SdsAccordionItemComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0$2, 5);
            i0.ɵɵviewQuery(_c1$2, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemTitleTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemContentTemplate = _t.first);
        } }, inputs: { expanded: "expanded", disabled: "disabled" }, ngContentSelectors: _c3$2, decls: 4, vars: 0, consts: [["itemTitleTemplate", ""], ["itemContentTemplate", ""]], template: function SdsAccordionItemComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef(_c2$2);
            i0.ɵɵtemplate(0, SdsAccordionItemComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, SdsAccordionItemComponent_ng_template_2_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsAccordionItemComponent, [{
        type: Component,
        args: [{
                selector: 'sds-accordion-item',
                template: `
    <ng-template #itemTitleTemplate>
      <ng-content #title select="sds-accordion-title"></ng-content>
    </ng-template>
    <ng-template #itemContentTemplate>
      <ng-content #content select="sds-accordion-content"></ng-content>
    </ng-template>
  `,
            }]
    }], null, { itemTitleTemplate: [{
            type: ViewChild,
            args: ['itemTitleTemplate']
        }], itemContentTemplate: [{
            type: ViewChild,
            args: ['itemContentTemplate']
        }], expanded: [{
            type: Input
        }], disabled: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SdsAccordionItemComponent, { className: "SdsAccordionItemComponent" }); })();
class SdsAccordionComponent {
    constructor() {
        this.multi = false;
        this.multiChange = new EventEmitter();
        this.displayMode = 'flat';
        console.warn(`This is a deprectaed version of accordion component, and will be removed in future versions. 
    Please switch to using usa-accordion from @gsa-sam/ngx-uswds (https://github.com/GSA/ngx-uswds)`);
    }
    /** Opens all accordion items. */
    openAll() {
        this.accordion.openAll();
    }
    /** Closes all accordion items. */
    closeAll() {
        this.accordion.closeAll();
    }
    /** Toggles the multi state of the accordion. */
    toggleMulti() {
        this.multi = !this.multi;
        this.accordion.closeAll();
        this.multiChange.emit(this.multi);
    }
    /** @nocollapse */ static { this.ɵfac = function SdsAccordionComponent_Factory(t) { return new (t || SdsAccordionComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: SdsAccordionComponent, selectors: [["sds-accordion-next"]], contentQueries: function SdsAccordionComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, SdsAccordionItemComponent, 4);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accordionItems = _t);
        } }, viewQuery: function SdsAccordionComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MatAccordion, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accordion = _t.first);
        } }, inputs: { multi: "multi", displayMode: "displayMode", collapsedHeight: "collapsedHeight", expandedHeight: "expandedHeight" }, outputs: { multiChange: "multiChange" }, decls: 2, vars: 3, consts: [[3, "displayMode", "multi"], [4, "ngFor", "ngForOf"], [3, "expandedChange", "expanded", "disabled"], [3, "collapsedHeight", "expandedHeight"], [1, "sds-expansion-indicator", 3, "ngClass"], [4, "ngTemplateOutlet"], [3, "ngClass"]], template: function SdsAccordionComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-accordion", 0);
            i0.ɵɵtemplate(1, SdsAccordionComponent_ng_container_1_Template, 8, 12, "ng-container", 1);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("displayMode", ctx.displayMode)("multi", ctx.multi);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.accordionItems);
        } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgTemplateOutlet, i2.MatAccordion, i2.MatExpansionPanel, i2.MatExpansionPanelHeader, i2.MatExpansionPanelTitle] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsAccordionComponent, [{
        type: Component,
        args: [{ selector: 'sds-accordion-next', template: "<mat-accordion [displayMode]=\"displayMode\" [multi]=\"multi\">\n  <ng-container *ngFor=\"let accordionItem of accordionItems\">\n    <mat-expansion-panel [(expanded)]=\"accordionItem.expanded\" [disabled]=\"accordionItem.disabled\">\n      <mat-expansion-panel-header [collapsedHeight]=\"collapsedHeight\" [expandedHeight]=\"expandedHeight\">\n        <mat-panel-title>\n          <span\n            class=\"sds-expansion-indicator\"\n            [ngClass]=\"{ 'sds-expansion-indicator--expanded': accordionItem.expanded }\"\n          ></span>\n          <ng-container *ngTemplateOutlet=\"accordionItem.itemTitleTemplate\"></ng-container>\n        </mat-panel-title>\n      </mat-expansion-panel-header>\n      <span [ngClass]=\"{ 'display-none': !accordionItem.expanded }\">\n        <ng-container *ngTemplateOutlet=\"accordionItem.itemContentTemplate\"></ng-container>\n      </span>\n    </mat-expansion-panel>\n  </ng-container>\n</mat-accordion>\n" }]
    }], () => [], { accordion: [{
            type: ViewChild,
            args: [MatAccordion]
        }], accordionItems: [{
            type: ContentChildren,
            args: [SdsAccordionItemComponent]
        }], multi: [{
            type: Input
        }], multiChange: [{
            type: Output
        }], displayMode: [{
            type: Input
        }], collapsedHeight: [{
            type: Input
        }], expandedHeight: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SdsAccordionComponent, { className: "SdsAccordionComponent" }); })();

class SdsAccordionModule {
    /** @nocollapse */ static { this.ɵfac = function SdsAccordionModule_Factory(t) { return new (t || SdsAccordionModule)(); }; }
    /** @nocollapse */ static { this.ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: SdsAccordionModule }); }
    /** @nocollapse */ static { this.ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ providers: [
            {
                provide: MAT_EXPANSION_PANEL_DEFAULT_OPTIONS,
                useValue: {
                    collapsedHeight: '45px',
                    expandedHeight: '45px',
                    hideToggle: true,
                },
            },
        ], imports: [CommonModule, MatExpansionModule, IconModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsAccordionModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SdsAccordionComponent,
                    SdsAccordionItemComponent,
                    SdsAccordionTitleDirective,
                    SdsAccordionContentDirective,
                ],
                imports: [CommonModule, MatExpansionModule, IconModule],
                exports: [SdsAccordionComponent, SdsAccordionItemComponent, SdsAccordionTitleDirective, SdsAccordionContentDirective],
                providers: [
                    {
                        provide: MAT_EXPANSION_PANEL_DEFAULT_OPTIONS,
                        useValue: {
                            collapsedHeight: '45px',
                            expandedHeight: '45px',
                            hideToggle: true,
                        },
                    },
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SdsAccordionModule, { declarations: [SdsAccordionComponent,
        SdsAccordionItemComponent,
        SdsAccordionTitleDirective,
        SdsAccordionContentDirective], imports: [CommonModule, MatExpansionModule, IconModule], exports: [SdsAccordionComponent, SdsAccordionItemComponent, SdsAccordionTitleDirective, SdsAccordionContentDirective] }); })();

class TableRowNavigationDirective {
    constructor(el, renderer, router) {
        this.el = el;
        this.renderer = renderer;
        this.router = router;
        this.hoverClass = 'sds-table__row--hovered';
        this.highlightOnHover = false;
    }
    onMouseEnter() {
        if (this.highlightOnHover) {
            this.addHoverClass();
        }
    }
    onMouseLeave() {
        if (this.highlightOnHover) {
            this.removeHoverClass();
        }
    }
    addHoverClass() {
        this.renderer.addClass(this.el.nativeElement, this.hoverClass);
    }
    removeHoverClass() {
        this.renderer.removeClass(this.el.nativeElement, this.hoverClass);
    }
    /** @nocollapse */ static { this.ɵfac = function TableRowNavigationDirective_Factory(t) { return new (t || TableRowNavigationDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1$1.Router)); }; }
    /** @nocollapse */ static { this.ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: TableRowNavigationDirective, selectors: [["tr", "mat-row", "", "sdsTableRowNavigation", ""]], hostBindings: function TableRowNavigationDirective_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("mouseenter", function TableRowNavigationDirective_mouseenter_HostBindingHandler() { return ctx.onMouseEnter(); })("mouseleave", function TableRowNavigationDirective_mouseleave_HostBindingHandler() { return ctx.onMouseLeave(); });
        } }, inputs: { highlightOnHover: "highlightOnHover" } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TableRowNavigationDirective, [{
        type: Directive,
        args: [{
                selector: 'tr[mat-row][sdsTableRowNavigation]',
            }]
    }], () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1$1.Router }], { highlightOnHover: [{
            type: Input
        }], onMouseEnter: [{
            type: HostListener,
            args: ['mouseenter']
        }], onMouseLeave: [{
            type: HostListener,
            args: ['mouseleave']
        }] }); })();

const _c0$1 = ["*"];
const _c1$1 = ["sdsHeaderCell"];
const _c2$1 = ["sdsCell"];
const _c3$1 = ["sdsFooterCell"];
const _c4 = ["columnHeaderCell"];
const _c5 = ["columnCell"];
const _c6 = ["columnFooterCell"];
const _c7 = a0 => ({ element: a0 });
function SdsTableColumnDefComponent_ng_template_0_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SdsTableColumnDefComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SdsTableColumnDefComponent_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 3);
} if (rf & 2) {
    const element_r1 = ctx.element;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerCellTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c7, element_r1));
} }
function SdsTableColumnDefComponent_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SdsTableColumnDefComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SdsTableColumnDefComponent_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 3);
} if (rf & 2) {
    const element_r3 = ctx.element;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.cellTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c7, element_r3));
} }
function SdsTableColumnDefComponent_ng_template_4_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SdsTableColumnDefComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, SdsTableColumnDefComponent_ng_template_4_ng_container_0_Template, 1, 0, "ng-container", 3);
} if (rf & 2) {
    const element_r4 = ctx.element;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.footerCellTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c7, element_r4));
} }
const _c8 = a0 => ({ "sds-table__container--borderless": a0 });
const _c9 = a0 => ({ "sds-table--expansion": a0 });
const _c10 = (a0, a1) => ({ "cursor-pointer": a0, "sds-table__row--expanded": a1 });
const _c11 = () => ["expandedDetail"];
const _c12 = () => [25, 50, 100];
function SdsTableComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "sds-pagination", 10);
    i0.ɵɵtwoWayListener("pageChange", function SdsTableComponent_div_0_Template_sds_pagination_pageChange_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.page, $event) || (ctx_r1.page = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("displayMode", "results")("paginationConfiguration", ctx_r1.top);
    i0.ɵɵtwoWayProperty("page", ctx_r1.page);
    i0.ɵɵproperty("totalItems", ctx_r1.totalItems);
} }
function SdsTableComponent_ng_container_3_ng_container_1_ng_container_1_th_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SdsTableComponent_ng_container_3_ng_container_1_ng_container_1_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 16);
    i0.ɵɵtemplate(1, SdsTableComponent_ng_container_3_ng_container_1_ng_container_1_th_1_ng_container_1_Template, 1, 0, "ng-container", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sdsColumnItem_r3 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", sdsColumnItem_r3.columnHeaderCell);
} }
function SdsTableComponent_ng_container_3_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SdsTableComponent_ng_container_3_ng_container_1_ng_container_1_th_1_Template, 2, 1, "th", 15);
    i0.ɵɵelementContainerEnd();
} }
function SdsTableComponent_ng_container_3_ng_container_1_ng_template_2_th_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SdsTableComponent_ng_container_3_ng_container_1_ng_template_2_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 19);
    i0.ɵɵtemplate(1, SdsTableComponent_ng_container_3_ng_container_1_ng_template_2_th_1_ng_container_1_Template, 1, 0, "ng-container", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sdsColumnItem_r3 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", sdsColumnItem_r3.columnHeaderCell);
} }
function SdsTableComponent_ng_container_3_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SdsTableComponent_ng_container_3_ng_container_1_ng_template_2_th_1_Template, 2, 1, "th", 18);
    i0.ɵɵelementContainerEnd();
} }
function SdsTableComponent_ng_container_3_ng_container_1_td_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SdsTableComponent_ng_container_3_ng_container_1_td_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 20);
    i0.ɵɵlistener("click", function SdsTableComponent_ng_container_3_ng_container_1_td_4_Template_td_click_0_listener() { const i_r5 = i0.ɵɵrestoreView(_r4).dataIndex; const sdsColumnItem_r3 = i0.ɵɵnextContext(2).$implicit; const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(sdsColumnItem_r3.isClickable ? ctx_r1.rowClicked.emit(i_r5) : true); });
    i0.ɵɵtemplate(1, SdsTableComponent_ng_container_3_ng_container_1_td_4_ng_container_1_Template, 1, 0, "ng-container", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r6 = ctx.$implicit;
    const sdsColumnItem_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", sdsColumnItem_r3.columnCell)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c7, element_r6));
} }
function SdsTableComponent_ng_container_3_ng_container_1_ng_container_5_th_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SdsTableComponent_ng_container_3_ng_container_1_ng_container_5_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 23);
    i0.ɵɵtemplate(1, SdsTableComponent_ng_container_3_ng_container_1_ng_container_5_th_1_ng_container_1_Template, 1, 0, "ng-container", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const sdsColumnItem_r3 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", sdsColumnItem_r3.columnFooterCell);
} }
function SdsTableComponent_ng_container_3_ng_container_1_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SdsTableComponent_ng_container_3_ng_container_1_ng_container_5_th_1_Template, 2, 1, "th", 22);
    i0.ɵɵelementContainerEnd();
} }
function SdsTableComponent_ng_container_3_ng_container_1_ng_container_6_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "td", 23);
} }
function SdsTableComponent_ng_container_3_ng_container_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SdsTableComponent_ng_container_3_ng_container_1_ng_container_6_td_1_Template, 1, 0, "td", 22);
    i0.ɵɵelementContainerEnd();
} }
function SdsTableComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 12);
    i0.ɵɵtemplate(1, SdsTableComponent_ng_container_3_ng_container_1_ng_container_1_Template, 2, 0, "ng-container", 13)(2, SdsTableComponent_ng_container_3_ng_container_1_ng_template_2_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, SdsTableComponent_ng_container_3_ng_container_1_td_4_Template, 2, 4, "td", 14)(5, SdsTableComponent_ng_container_3_ng_container_1_ng_container_5_Template, 2, 0, "ng-container", 5)(6, SdsTableComponent_ng_container_3_ng_container_1_ng_container_6_Template, 2, 0, "ng-container", 5);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const basicColumn_r7 = i0.ɵɵreference(3);
    const sdsColumnItem_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵpropertyInterpolate("matColumnDef", sdsColumnItem_r3.sdsColumnName);
    i0.ɵɵproperty("sticky", sdsColumnItem_r3.sticky)("stickyEnd", sdsColumnItem_r3.stickyEnd);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.sort === "true" || ctx_r1.sort === "" || ctx_r1.typeOf(ctx_r1.sort) === "object" && ctx_r1.isArray(ctx_r1.sort) && ctx_r1.sort.includes(sdsColumnItem_r3.sdsColumnName))("ngIfElse", basicColumn_r7);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", sdsColumnItem_r3.footerCellTemplate);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !sdsColumnItem_r3.footerCellTemplate);
} }
function SdsTableComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SdsTableComponent_ng_container_3_ng_container_1_Template, 7, 7, "ng-container", 11);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const sdsColumnItem_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !sdsColumnItem_r3.sdsExpandedTemplate);
} }
function SdsTableComponent_ng_container_4_ng_container_1_ng_container_1_td_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SdsTableComponent_ng_container_4_ng_container_1_ng_container_1_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 27)(1, "div", 28);
    i0.ɵɵtemplate(2, SdsTableComponent_ng_container_4_ng_container_1_ng_container_1_td_1_ng_container_2_Template, 1, 0, "ng-container", 21);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const element_r8 = ctx.$implicit;
    const sdsColumnItem_r9 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("colspan", ctx_r1.rowConfig.displayedColumns.length);
    i0.ɵɵadvance();
    i0.ɵɵproperty("@detailExpand", element_r8 == ctx_r1.expandedElement ? "expanded" : "collapsed");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", sdsColumnItem_r9.columnCell)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c7, element_r8));
} }
function SdsTableComponent_ng_container_4_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 25);
    i0.ɵɵtemplate(1, SdsTableComponent_ng_container_4_ng_container_1_ng_container_1_td_1_Template, 3, 6, "td", 26);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const sdsColumnItem_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵpropertyInterpolate("matColumnDef", sdsColumnItem_r9.sdsColumnName);
} }
function SdsTableComponent_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SdsTableComponent_ng_container_4_ng_container_1_ng_container_1_Template, 2, 1, "ng-container", 24);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const sdsColumnItem_r9 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", sdsColumnItem_r9.sdsExpandedTemplate);
} }
function SdsTableComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SdsTableComponent_ng_container_4_ng_container_1_Template, 2, 1, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.sdsColumnItems);
} }
function SdsTableComponent_ng_container_5_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "th", 33);
} }
function SdsTableComponent_ng_container_5_td_2_usa_icon_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "usa-icon", 36);
} if (rf & 2) {
    i0.ɵɵproperty("icon", "dash");
} }
function SdsTableComponent_ng_container_5_td_2_usa_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "usa-icon", 36);
} if (rf & 2) {
    i0.ɵɵproperty("icon", "uswds-add");
} }
function SdsTableComponent_ng_container_5_td_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 34);
    i0.ɵɵlistener("click", function SdsTableComponent_ng_container_5_td_2_Template_td_click_0_listener() { const element_r11 = i0.ɵɵrestoreView(_r10).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onExpansionClicked(element_r11)); })("keydown.enter", function SdsTableComponent_ng_container_5_td_2_Template_td_keydown_enter_0_listener() { const element_r11 = i0.ɵɵrestoreView(_r10).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onExpansionClicked(element_r11)); })("keydown.space", function SdsTableComponent_ng_container_5_td_2_Template_td_keydown_space_0_listener() { const element_r11 = i0.ɵɵrestoreView(_r10).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onExpansionClicked(element_r11)); });
    i0.ɵɵtemplate(1, SdsTableComponent_ng_container_5_td_2_usa_icon_1_Template, 1, 1, "usa-icon", 35)(2, SdsTableComponent_ng_container_5_td_2_usa_icon_2_Template, 1, 1, "usa-icon", 35);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r11 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("aria-expanded", element_r11 == ctx_r1.expandedElement ? "true" : "false")("aria-label", element_r11 == ctx_r1.expandedElement ? ctx_r1.expandedAriaLabel : ctx_r1.collapsedAriaLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", element_r11 == ctx_r1.expandedElement);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", element_r11 != ctx_r1.expandedElement);
} }
function SdsTableComponent_ng_container_5_td_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "td", 37);
} }
function SdsTableComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 29);
    i0.ɵɵtemplate(1, SdsTableComponent_ng_container_5_th_1_Template, 1, 0, "th", 30)(2, SdsTableComponent_ng_container_5_td_2_Template, 3, 4, "td", 31)(3, SdsTableComponent_ng_container_5_td_3_Template, 1, 0, "td", 32);
    i0.ɵɵelementContainerEnd();
} }
function SdsTableComponent_ng_container_6_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 39);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.headerColor);
} }
function SdsTableComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SdsTableComponent_ng_container_6_tr_1_Template, 1, 1, "tr", 38);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("matHeaderRowDef", ctx_r1.headerRowConfig.displayedColumns)("matHeaderRowDefSticky", ctx_r1.headerRowConfig.sticky);
} }
function SdsTableComponent_tr_7_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 40);
    i0.ɵɵlistener("click", function SdsTableComponent_tr_7_Template_tr_click_0_listener() { const ctx_r12 = i0.ɵɵrestoreView(_r12); const row_r14 = ctx_r12.$implicit; const i_r15 = ctx_r12.dataIndex; const ctx_r1 = i0.ɵɵnextContext(); ctx_r1.rowConfig.expandOnClick ? ctx_r1.expandedElement = ctx_r1.expandedElement === row_r14 ? null : row_r14 : false; return i0.ɵɵresetView(ctx_r1.columnsClickable ? false : ctx_r1.rowClicked.emit(i_r15)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const row_r14 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMapInterpolate1("sds-table__row ", row_r14["classesToApply"], "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c10, ctx_r1.rowConfig.expandOnClick, ctx_r1.expandedElement == row_r14))("highlightOnHover", ctx_r1.rowConfig.highlightOnHover);
} }
function SdsTableComponent_ng_container_8_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 42);
} }
function SdsTableComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SdsTableComponent_ng_container_8_tr_1_Template, 1, 0, "tr", 41);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("matRowDefColumns", i0.ɵɵpureFunction0(1, _c11));
} }
function SdsTableComponent_ng_container_9_tr_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 44);
} }
function SdsTableComponent_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, SdsTableComponent_ng_container_9_tr_1_Template, 1, 0, "tr", 43);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("matFooterRowDef", ctx_r1.footerRowConfig.displayedColumns)("matFooterRowDefSticky", ctx_r1.footerRowConfig.sticky);
} }
function SdsTableComponent_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-paginator", 45);
    i0.ɵɵlistener("page", function SdsTableComponent_ng_container_11_Template_mat_paginator_page_1_listener($event) { i0.ɵɵrestoreView(_r16); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.pageEvent = $event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("pageSizeOptions", i0.ɵɵpureFunction0(1, _c12));
} }
function SdsTableComponent_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "sds-pagination", 46);
    i0.ɵɵtwoWayListener("pageChange", function SdsTableComponent_div_12_Template_sds_pagination_pageChange_1_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.page, $event) || (ctx_r1.page = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("pageChange", function SdsTableComponent_div_12_Template_sds_pagination_pageChange_1_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.pageChange.next($event)); })("initialized", function SdsTableComponent_div_12_Template_sds_pagination_initialized_1_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.pageChange.next($event)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("paginationConfiguration", ctx_r1.bottom);
    i0.ɵɵtwoWayProperty("page", ctx_r1.page);
} }
var SdsTableHeaderColor;
(function (SdsTableHeaderColor) {
    SdsTableHeaderColor["InfoLighter"] = "header-info-lighter";
    SdsTableHeaderColor["AccentCoolLight"] = "header-accent-cool-light";
    SdsTableHeaderColor["PrimaryLighter"] = "header-primary-lighter";
})(SdsTableHeaderColor || (SdsTableHeaderColor = {}));
class SdsTableRowComponent {
    constructor() {
        this.expandOnClick = false;
        this.highlightOnHover = false;
    }
    /** @nocollapse */ static { this.ɵfac = function SdsTableRowComponent_Factory(t) { return new (t || SdsTableRowComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: SdsTableRowComponent, selectors: [["sds-row"]], inputs: { displayedColumns: "displayedColumns", expandOnClick: "expandOnClick", highlightOnHover: "highlightOnHover", rowClickNavigate: "rowClickNavigate" }, ngContentSelectors: _c0$1, decls: 1, vars: 0, template: function SdsTableRowComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsTableRowComponent, [{
        type: Component,
        args: [{
                selector: 'sds-row',
                template: ` <ng-content></ng-content> `,
            }]
    }], null, { displayedColumns: [{
            type: Input
        }], expandOnClick: [{
            type: Input
        }], highlightOnHover: [{
            type: Input
        }], rowClickNavigate: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SdsTableRowComponent, { className: "SdsTableRowComponent" }); })();
class SdsTableHeaderRowComponent {
    /** @nocollapse */ static { this.ɵfac = function SdsTableHeaderRowComponent_Factory(t) { return new (t || SdsTableHeaderRowComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: SdsTableHeaderRowComponent, selectors: [["sds-header-row"]], inputs: { displayedColumns: "displayedColumns", sticky: "sticky" }, ngContentSelectors: _c0$1, decls: 1, vars: 0, template: function SdsTableHeaderRowComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsTableHeaderRowComponent, [{
        type: Component,
        args: [{
                selector: 'sds-header-row',
                template: ` <ng-content></ng-content> `,
            }]
    }], null, { displayedColumns: [{
            type: Input
        }], sticky: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SdsTableHeaderRowComponent, { className: "SdsTableHeaderRowComponent" }); })();
class SdsTableFooterRowComponent {
    /** @nocollapse */ static { this.ɵfac = function SdsTableFooterRowComponent_Factory(t) { return new (t || SdsTableFooterRowComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: SdsTableFooterRowComponent, selectors: [["sds-footer-row"]], inputs: { displayedColumns: "displayedColumns", sticky: "sticky" }, ngContentSelectors: _c0$1, decls: 1, vars: 0, template: function SdsTableFooterRowComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵprojection(0);
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsTableFooterRowComponent, [{
        type: Component,
        args: [{
                selector: 'sds-footer-row',
                template: ` <ng-content></ng-content> `,
            }]
    }], null, { displayedColumns: [{
            type: Input
        }], sticky: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SdsTableFooterRowComponent, { className: "SdsTableFooterRowComponent" }); })();
class SdsTableHeaderCellDirective {
    /** @nocollapse */ static { this.ɵfac = function SdsTableHeaderCellDirective_Factory(t) { return new (t || SdsTableHeaderCellDirective)(); }; }
    /** @nocollapse */ static { this.ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: SdsTableHeaderCellDirective, selectors: [["sds-table-headercell"]] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsTableHeaderCellDirective, [{
        type: Directive,
        args: [{ selector: 'sds-table-headercell' }]
    }], null, null); })();
class SdsTableCellDirective {
    /** @nocollapse */ static { this.ɵfac = function SdsTableCellDirective_Factory(t) { return new (t || SdsTableCellDirective)(); }; }
    /** @nocollapse */ static { this.ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: SdsTableCellDirective, selectors: [["sds-table-cell"]] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsTableCellDirective, [{
        type: Directive,
        args: [{ selector: 'sds-table-cell' }]
    }], null, null); })();
class SdsTableFooterCellDirective {
    /** @nocollapse */ static { this.ɵfac = function SdsTableFooterCellDirective_Factory(t) { return new (t || SdsTableFooterCellDirective)(); }; }
    /** @nocollapse */ static { this.ɵdir = /** @pureOrBreakMyCode */ i0.ɵɵdefineDirective({ type: SdsTableFooterCellDirective, selectors: [["sds-table-footercell"]] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsTableFooterCellDirective, [{
        type: Directive,
        args: [{ selector: 'sds-table-footercell' }]
    }], null, null); })();
class SdsTableColumnDefComponent {
    constructor() {
        this.sticky = false;
        this.stickyEnd = false;
        this.sdsExpandedTemplate = false;
        this.isClickable = false;
    }
    ngAfterContentInit() { }
    /** @nocollapse */ static { this.ɵfac = function SdsTableColumnDefComponent_Factory(t) { return new (t || SdsTableColumnDefComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: SdsTableColumnDefComponent, selectors: [["sds-table-column"]], contentQueries: function SdsTableColumnDefComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, _c1$1, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, _c2$1, 5, TemplateRef);
            i0.ɵɵcontentQuery(dirIndex, _c3$1, 5, TemplateRef);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerCellTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cellTemplate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerCellTemplate = _t.first);
        } }, viewQuery: function SdsTableColumnDefComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c4, 7);
            i0.ɵɵviewQuery(_c5, 7);
            i0.ɵɵviewQuery(_c6, 7);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.columnHeaderCell = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.columnCell = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.columnFooterCell = _t.first);
        } }, inputs: { sdsColumnName: "sdsColumnName", sticky: "sticky", stickyEnd: "stickyEnd", sdsExpandedTemplate: "sdsExpandedTemplate", isClickable: "isClickable" }, decls: 6, vars: 0, consts: [["columnHeaderCell", ""], ["columnCell", ""], ["columnFooterCell", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function SdsTableColumnDefComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, SdsTableColumnDefComponent_ng_template_0_Template, 1, 4, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, SdsTableColumnDefComponent_ng_template_2_Template, 1, 4, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, SdsTableColumnDefComponent_ng_template_4_Template, 1, 4, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
        } }, dependencies: [i1.NgTemplateOutlet], encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsTableColumnDefComponent, [{
        type: Component,
        args: [{
                selector: 'sds-table-column',
                template: `
    <ng-template #columnHeaderCell let-element="element">
      <ng-container *ngTemplateOutlet="headerCellTemplate; context: { element: element }"></ng-container>
    </ng-template>

    <ng-template #columnCell let-element="element">
      <ng-container *ngTemplateOutlet="cellTemplate; context: { element: element }"></ng-container>
    </ng-template>

    <ng-template #columnFooterCell let-element="element">
      <ng-container *ngTemplateOutlet="footerCellTemplate; context: { element: element }"></ng-container>
    </ng-template>
  `,
            }]
    }], null, { columnHeaderCell: [{
            type: ViewChild,
            args: ['columnHeaderCell', { static: true }]
        }], columnCell: [{
            type: ViewChild,
            args: ['columnCell', { static: true }]
        }], columnFooterCell: [{
            type: ViewChild,
            args: ['columnFooterCell', { static: true }]
        }], headerCellTemplate: [{
            type: ContentChild,
            args: ['sdsHeaderCell', { read: TemplateRef }]
        }], cellTemplate: [{
            type: ContentChild,
            args: ['sdsCell', { read: TemplateRef }]
        }], footerCellTemplate: [{
            type: ContentChild,
            args: ['sdsFooterCell', { read: TemplateRef }]
        }], sdsColumnName: [{
            type: Input
        }], sticky: [{
            type: Input
        }], stickyEnd: [{
            type: Input
        }], sdsExpandedTemplate: [{
            type: Input
        }], isClickable: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SdsTableColumnDefComponent, { className: "SdsTableColumnDefComponent" }); })();
class SdsTableComponent {
    /**
     * Borderless table
     */
    set borderless(borderless) {
        this._borderless = borderless;
    }
    get borderless() {
        return this._borderless;
    }
    /**
     * Pagination table
     */
    set pagination(pagination) {
        this._pagination = pagination;
    }
    get pagination() {
        return this._pagination;
    }
    /**
     * Expansion table
     */
    set expansion(expansion) {
        this._expansion = expansion;
    }
    get expansion() {
        return this._expansion;
    }
    constructor(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this._borderless = false;
        /**
         * Sorting table
         */
        this.sort = 'false';
        this._pagination = false;
        this._expansion = false;
        this.expandedAriaLabel = 'Collapse details';
        this.collapsedAriaLabel = 'Expand details';
        this.expansionClicked = new EventEmitter();
        this.rowClicked = new EventEmitter();
        this.rowConfig = {};
        this.headerRowConfig = {};
        this.footerRowConfig = {};
        /* sds pagination */
        this.top = { id: 'top' };
        this.bottom = { id: 'bottom' };
        this.page = {};
        this.pageChange = new BehaviorSubject(this.page);
        this.showPagination = false;
    }
    ngOnChanges(changes) {
        if (changes.data?.currentValue) {
            this.dataSource = new MatTableDataSource(changes.data.currentValue);
            if (this.sort === 'true' || this.sort === '' || this.isArray(this.sort)) {
                this.dataSource.sortingDataAccessor = this.sortFn ? this.sortFn : this.defaultSort;
                this.dataSource.sort = this.matSort;
            }
            if (this.pagination) {
                this.dataSource.paginator = this.matPaginator;
                this.updateSdsPagination();
            }
        }
    }
    ngOnInit() {
        this.dataSource = new MatTableDataSource(this.data);
        if (this.tableName) {
            this.top = { id: this.tableName + 'Top' };
            this.bottom = { id: this.tableName + 'Bottom' };
        }
    }
    ngAfterContentInit() {
        this.rowConfig.displayedColumns = this.sdsTableRowComponent.displayedColumns;
        this.rowConfig.expandOnClick = this.sdsTableRowComponent.expandOnClick;
        this.rowConfig.highlightOnHover = this.sdsTableRowComponent.highlightOnHover;
        this.rowConfig.rowClickNavigate = this.sdsTableRowComponent.rowClickNavigate;
        if (this.sdsTableHeaderRowComponent) {
            this.headerRowConfig.displayedColumns = this.sdsTableHeaderRowComponent.displayedColumns;
            this.headerRowConfig.sticky = this.sdsTableHeaderRowComponent.sticky;
        }
        if (this.sdsTableFooterRowComponent) {
            this.footerRowConfig.displayedColumns = this.sdsTableFooterRowComponent.displayedColumns;
            this.footerRowConfig.sticky = this.sdsTableFooterRowComponent.sticky;
        }
        if (this.expansion) {
            const expandedIndicator = 'expandedIndicator';
            if (this.rowConfig.displayedColumns && !this.rowConfig.displayedColumns.includes(expandedIndicator)) {
                this.rowConfig.displayedColumns.unshift('expandedIndicator');
            }
        }
    }
    ngAfterViewInit() {
        if (this.sort === 'true' || this.sort === '' || this.isArray(this.sort)) {
            this.dataSource.sortingDataAccessor = this.sortFn ? this.sortFn : this.defaultSort;
            this.dataSource.sort = this.matSort;
        }
        if (this.pagination) {
            this.dataSource.paginator = this.matPaginator;
            this.dataSource.paginator.initialized.subscribe((value) => {
                setTimeout(() => {
                    this.page = {
                        pageNumber: this.dataSource.paginator.pageIndex + 1,
                        pageSize: this.dataSource.paginator.pageSize,
                        totalPages: this.dataSource.paginator.getNumberOfPages(),
                    };
                    this.totalItems = this.dataSource.data.length;
                    this.showPagination = true;
                    this.changeDetectorRef.detectChanges();
                });
            });
            this.pageChange.subscribe((value) => {
                this.updateSdsPagination();
            });
            this.changeDetectorRef.detectChanges();
        }
    }
    typeOf(value) {
        return typeof value;
    }
    isArray(obj) {
        return Array.isArray(obj);
    }
    updateSdsPagination() {
        if (this.page && this.dataSource?.paginator) {
            this.dataSource.paginator.pageIndex = this.page.pageNumber - 1;
            this.dataSource.paginator._changePageSize(this.page.pageSize);
            this.page.totalPages = Math.ceil(this.dataSource.data.length / this.page.pageSize);
            this.totalItems = this.dataSource.data.length;
            this.changeDetectorRef.detectChanges();
        }
    }
    defaultSort(data, sortHeaderId) {
        if (typeof data[sortHeaderId] === 'string') {
            return data[sortHeaderId].toLocaleLowerCase();
        }
        return data[sortHeaderId];
    }
    onExpansionClicked(element) {
        !this.rowConfig.expandOnClick ? (this.expandedElement = this.expandedElement === element ? null : element) : false;
        this.expansionClicked.emit(this.expandedElement);
    }
    get columnsClickable() {
        return this.sdsColumnItems.filter((item) => item.isClickable).length > 0;
    }
    /** @nocollapse */ static { this.ɵfac = function SdsTableComponent_Factory(t) { return new (t || SdsTableComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: SdsTableComponent, selectors: [["sds-table"]], contentQueries: function SdsTableComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, SdsTableRowComponent, 5);
            i0.ɵɵcontentQuery(dirIndex, SdsTableHeaderRowComponent, 5);
            i0.ɵɵcontentQuery(dirIndex, SdsTableFooterRowComponent, 5);
            i0.ɵɵcontentQuery(dirIndex, SdsTableColumnDefComponent, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sdsTableRowComponent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sdsTableHeaderRowComponent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sdsTableFooterRowComponent = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sdsColumnItems = _t);
        } }, viewQuery: function SdsTableComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MatTable, 5);
            i0.ɵɵviewQuery(MatSort, 5);
            i0.ɵɵviewQuery(MatPaginator, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.table = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.matSort = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.matPaginator = _t.first);
        } }, inputs: { data: "data", borderless: "borderless", sort: "sort", sortFn: "sortFn", tableName: "tableName", pagination: "pagination", expansion: "expansion", expandedAriaLabel: "expandedAriaLabel", collapsedAriaLabel: "collapsedAriaLabel", headerColor: "headerColor" }, outputs: { expansionClicked: "expansionClicked", rowClicked: "rowClicked" }, features: [i0.ɵɵNgOnChangesFeature], decls: 13, vars: 18, consts: [["basicColumn", ""], ["class", "margin-y-05", 4, "ngIf"], [1, "sds-table__container", 3, "ngClass"], ["mat-table", "", "matSort", "", "multiTemplateDataRows", "", 1, "sds-table", "width-full", "mat-elevation-z8", 3, "dataSource", "ngClass"], [4, "ngFor", "ngForOf"], [4, "ngIf"], ["matColumnDef", "expandedIndicator", 4, "ngIf"], ["mat-row", "", "sdsTableRowNavigation", "", 3, "class", "ngClass", "highlightOnHover", "click", 4, "matRowDef", "matRowDefColumns"], [3, "hidden"], [1, "margin-y-05"], [3, "pageChange", "displayMode", "paginationConfiguration", "page", "totalItems"], [3, "matColumnDef", "sticky", "stickyEnd", 4, "ngIf"], [3, "matColumnDef", "sticky", "stickyEnd"], [4, "ngIf", "ngIfElse"], ["mat-cell", "", 3, "click", 4, "matCellDef"], ["mat-header-cell", "", "scope", "col", "mat-sort-header", "", 4, "matHeaderCellDef"], ["mat-header-cell", "", "scope", "col", "mat-sort-header", ""], [4, "ngTemplateOutlet"], ["mat-header-cell", "", "scope", "col", 4, "matHeaderCellDef"], ["mat-header-cell", "", "scope", "col"], ["mat-cell", "", 3, "click"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["mat-footer-cell", "", "scope", "col", 4, "matFooterCellDef"], ["mat-footer-cell", "", "scope", "col"], [3, "matColumnDef", 4, "ngIf"], [3, "matColumnDef"], ["mat-cell", "", "class", "sds-table__cell--detail", "role", "cell", 4, "matCellDef"], ["mat-cell", "", "role", "cell", 1, "sds-table__cell--detail"], [1, "sds-table__cell__expanded-wrapper"], ["matColumnDef", "expandedIndicator"], ["mat-header-cell", "", "class", "maxw-3 padding-top-2 padding-right-0 padding-left-1", 4, "matHeaderCellDef"], ["mat-cell", "", "class", "cursor-pointer maxw-3 padding-top-2 padding-right-0 padding-left-1", "tabindex", "0", 3, "click", "keydown.enter", "keydown.space", 4, "matCellDef"], ["mat-footer-cell", "", 4, "matFooterCellDef"], ["mat-header-cell", "", 1, "maxw-3", "padding-top-2", "padding-right-0", "padding-left-1"], ["mat-cell", "", "tabindex", "0", 1, "cursor-pointer", "maxw-3", "padding-top-2", "padding-right-0", "padding-left-1", 3, "click", "keydown.enter", "keydown.space"], ["size", "lg", 3, "icon", 4, "ngIf"], ["size", "lg", 3, "icon"], ["mat-footer-cell", ""], ["mat-header-row", "", 3, "ngClass", 4, "matHeaderRowDef", "matHeaderRowDefSticky"], ["mat-header-row", "", 3, "ngClass"], ["mat-row", "", "sdsTableRowNavigation", "", 3, "click", "ngClass", "highlightOnHover"], ["mat-row", "", "class", "sds-table__row--detail", 4, "matRowDef", "matRowDefColumns"], ["mat-row", "", 1, "sds-table__row--detail"], ["mat-footer-row", "", 4, "matFooterRowDef", "matFooterRowDefSticky"], ["mat-footer-row", ""], ["showFirstLastButtons", "", 3, "page", "pageSizeOptions"], [3, "pageChange", "initialized", "paginationConfiguration", "page"]], template: function SdsTableComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, SdsTableComponent_div_0_Template, 2, 4, "div", 1);
            i0.ɵɵelementStart(1, "div", 2)(2, "table", 3);
            i0.ɵɵtemplate(3, SdsTableComponent_ng_container_3_Template, 2, 1, "ng-container", 4)(4, SdsTableComponent_ng_container_4_Template, 2, 1, "ng-container", 5)(5, SdsTableComponent_ng_container_5_Template, 4, 0, "ng-container", 6)(6, SdsTableComponent_ng_container_6_Template, 2, 2, "ng-container", 5)(7, SdsTableComponent_tr_7_Template, 1, 8, "tr", 7)(8, SdsTableComponent_ng_container_8_Template, 2, 2, "ng-container", 5)(9, SdsTableComponent_ng_container_9_Template, 2, 2, "ng-container", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 8);
            i0.ɵɵtemplate(11, SdsTableComponent_ng_container_11_Template, 2, 2, "ng-container", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(12, SdsTableComponent_div_12_Template, 2, 2, "div", 5);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.pagination && ctx.showPagination);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c8, ctx.borderless));
            i0.ɵɵadvance();
            i0.ɵɵproperty("dataSource", ctx.dataSource)("ngClass", i0.ɵɵpureFunction1(16, _c9, ctx.expansion));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.sdsColumnItems);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.expansion);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.expansion);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.headerRowConfig && ctx.headerRowConfig.displayedColumns);
            i0.ɵɵadvance();
            i0.ɵɵproperty("matRowDefColumns", ctx.rowConfig.displayedColumns);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.expansion);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.footerRowConfig && ctx.footerRowConfig.displayedColumns);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", true);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.pagination);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.pagination && ctx.showPagination);
        } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i1.NgTemplateOutlet, i2$1.MatSort, i2$1.MatSortHeader, i3.MatTable, i3.MatHeaderCellDef, i3.MatHeaderRowDef, i3.MatColumnDef, i3.MatCellDef, i3.MatRowDef, i3.MatFooterCellDef, i3.MatFooterRowDef, i3.MatHeaderCell, i3.MatCell, i3.MatFooterCell, i3.MatHeaderRow, i3.MatRow, i3.MatFooterRow, i4.MatPaginator, i5.PaginationComponent, i6.IconComponent, TableRowNavigationDirective], styles: ["tr.header-info-lighter[_ngcontent-%COMP%]{background-color:#e7f6f8}tr.header-accent-cool-light[_ngcontent-%COMP%]{background-color:#d9e8f6}tr.header-primary-lighter[_ngcontent-%COMP%]{background-color:#e3f5e1}"], data: { animation: [
                trigger('detailExpand', [
                    state('collapsed', style({ height: '0px', minHeight: '0' })),
                    state('expanded', style({ height: '*' })),
                    transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                ]),
            ] } }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsTableComponent, [{
        type: Component,
        args: [{ selector: 'sds-table', animations: [
                    trigger('detailExpand', [
                        state('collapsed', style({ height: '0px', minHeight: '0' })),
                        state('expanded', style({ height: '*' })),
                        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                    ]),
                ], template: "<div class=\"margin-y-05\" *ngIf=\"pagination && showPagination\">\n  <sds-pagination\n    [displayMode]=\"'results'\"\n    [paginationConfiguration]=\"top\"\n    [(page)]=\"page\"\n    [totalItems]=\"totalItems\"\n  ></sds-pagination>\n</div>\n\n<div class=\"sds-table__container\" [ngClass]=\"{ 'sds-table__container--borderless': borderless }\">\n  <table\n    mat-table\n    [dataSource]=\"dataSource\"\n    class=\"sds-table width-full mat-elevation-z8\"\n    matSort\n    multiTemplateDataRows\n    [ngClass]=\"{ 'sds-table--expansion': expansion }\"\n  >\n    <ng-container *ngFor=\"let sdsColumnItem of sdsColumnItems\">\n      <ng-container\n        *ngIf=\"!sdsColumnItem.sdsExpandedTemplate\"\n        matColumnDef=\"{{ sdsColumnItem.sdsColumnName }}\"\n        [sticky]=\"sdsColumnItem.sticky\"\n        [stickyEnd]=\"sdsColumnItem.stickyEnd\"\n      >\n        <ng-container\n          *ngIf=\"\n            sort === 'true' ||\n              sort === '' ||\n              (typeOf(sort) === 'object' && isArray(sort) && sort.includes(sdsColumnItem.sdsColumnName));\n            else basicColumn\n          \"\n        >\n          <th mat-header-cell *matHeaderCellDef scope=\"col\" mat-sort-header>\n            <ng-container *ngTemplateOutlet=\"sdsColumnItem.columnHeaderCell\"></ng-container>\n          </th>\n        </ng-container>\n        <ng-template #basicColumn>\n          <ng-container>\n            <th mat-header-cell *matHeaderCellDef scope=\"col\">\n              <ng-container *ngTemplateOutlet=\"sdsColumnItem.columnHeaderCell\"></ng-container>\n            </th>\n          </ng-container>\n        </ng-template>\n        <td\n          mat-cell\n          *matCellDef=\"let element; let i = dataIndex\"\n          (click)=\"sdsColumnItem.isClickable ? rowClicked.emit(i) : true\"\n        >\n          <ng-container *ngTemplateOutlet=\"sdsColumnItem.columnCell; context: { element: element }\"></ng-container>\n        </td>\n        <ng-container *ngIf=\"sdsColumnItem.footerCellTemplate\">\n          <th mat-footer-cell *matFooterCellDef scope=\"col\">\n            <ng-container *ngTemplateOutlet=\"sdsColumnItem.columnFooterCell\"></ng-container>\n          </th>\n        </ng-container>\n        <ng-container *ngIf=\"!sdsColumnItem.footerCellTemplate\">\n          <td mat-footer-cell *matFooterCellDef scope=\"col\"></td>\n        </ng-container>\n      </ng-container>\n    </ng-container>\n\n    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->\n    <ng-container *ngIf=\"expansion\">\n      <ng-container *ngFor=\"let sdsColumnItem of sdsColumnItems\">\n        <ng-container *ngIf=\"sdsColumnItem.sdsExpandedTemplate\" matColumnDef=\"{{ sdsColumnItem.sdsColumnName }}\">\n          <td\n            mat-cell\n            *matCellDef=\"let element\"\n            [attr.colspan]=\"rowConfig.displayedColumns.length\"\n            class=\"sds-table__cell--detail\"\n            role=\"cell\"\n          >\n            <div\n              class=\"sds-table__cell__expanded-wrapper\"\n              [@detailExpand]=\"element == expandedElement ? 'expanded' : 'collapsed'\"\n            >\n              <ng-container *ngTemplateOutlet=\"sdsColumnItem.columnCell; context: { element: element }\"></ng-container>\n            </div>\n          </td>\n        </ng-container>\n      </ng-container>\n    </ng-container>\n\n    <ng-container *ngIf=\"expansion\" matColumnDef=\"expandedIndicator\">\n      <th mat-header-cell *matHeaderCellDef class=\"maxw-3 padding-top-2 padding-right-0 padding-left-1\"></th>\n      <td\n        mat-cell\n        *matCellDef=\"let element\"\n        class=\"cursor-pointer maxw-3 padding-top-2 padding-right-0 padding-left-1\"\n        (click)=\"onExpansionClicked(element)\"\n        [attr.aria-expanded]=\"element == expandedElement ? 'true' : 'false'\"\n        [attr.aria-label]=\"element == expandedElement ? expandedAriaLabel : collapsedAriaLabel\"\n        tabindex=\"0\"\n        (keydown.enter)=\"onExpansionClicked(element)\"\n        (keydown.space)=\"onExpansionClicked(element)\"\n      >\n        <usa-icon *ngIf=\"element == expandedElement\" [icon]=\"'dash'\" size=\"lg\"></usa-icon>\n        <usa-icon *ngIf=\"element != expandedElement\" [icon]=\"'uswds-add'\" size=\"lg\"></usa-icon>\n      </td>\n      <td mat-footer-cell *matFooterCellDef></td>\n    </ng-container>\n\n    <ng-container *ngIf=\"headerRowConfig && headerRowConfig.displayedColumns\">\n      <tr\n        mat-header-row\n        *matHeaderRowDef=\"headerRowConfig.displayedColumns; sticky: headerRowConfig.sticky\"\n        [ngClass]=\"headerColor\"\n      ></tr>\n    </ng-container>\n\n    <tr\n      mat-row\n      *matRowDef=\"let row; columns: rowConfig.displayedColumns; let i = dataIndex\"\n      class=\"sds-table__row {{ row['classesToApply'] }}\"\n      [ngClass]=\"{ 'cursor-pointer': rowConfig.expandOnClick, 'sds-table__row--expanded': expandedElement == row }\"\n      (click)=\"\n        rowConfig.expandOnClick ? (expandedElement = expandedElement === row ? null : row) : false;\n        columnsClickable ? false : rowClicked.emit(i)\n      \"\n      sdsTableRowNavigation\n      [highlightOnHover]=\"rowConfig.highlightOnHover\"\n    ></tr>\n\n    <ng-container *ngIf=\"expansion\">\n      <tr mat-row *matRowDef=\"let row; columns: ['expandedDetail']\" class=\"sds-table__row--detail\"></tr>\n    </ng-container>\n\n    <ng-container *ngIf=\"footerRowConfig && footerRowConfig.displayedColumns\">\n      <tr mat-footer-row *matFooterRowDef=\"footerRowConfig.displayedColumns; sticky: footerRowConfig.sticky\"></tr>\n    </ng-container>\n  </table>\n\n  <div [hidden]=\"true\">\n    <ng-container *ngIf=\"pagination\">\n      <mat-paginator [pageSizeOptions]=\"[25, 50, 100]\" showFirstLastButtons (page)=\"pageEvent = $event\"></mat-paginator>\n    </ng-container>\n  </div>\n</div>\n\n<div *ngIf=\"pagination && showPagination\">\n  <sds-pagination\n    [paginationConfiguration]=\"bottom\"\n    [(page)]=\"page\"\n    (pageChange)=\"pageChange.next($event)\"\n    (initialized)=\"pageChange.next($event)\"\n  ></sds-pagination>\n</div>\n", styles: ["tr.header-info-lighter{background-color:#e7f6f8}tr.header-accent-cool-light{background-color:#d9e8f6}tr.header-primary-lighter{background-color:#e3f5e1}\n"] }]
    }], () => [{ type: i0.ChangeDetectorRef }], { data: [{
            type: Input
        }], borderless: [{
            type: Input
        }], sort: [{
            type: Input
        }], sortFn: [{
            type: Input
        }], tableName: [{
            type: Input
        }], pagination: [{
            type: Input
        }], expansion: [{
            type: Input
        }], expandedAriaLabel: [{
            type: Input
        }], collapsedAriaLabel: [{
            type: Input
        }], headerColor: [{
            type: Input
        }], expansionClicked: [{
            type: Output
        }], rowClicked: [{
            type: Output
        }], table: [{
            type: ViewChild,
            args: [MatTable]
        }], sdsTableRowComponent: [{
            type: ContentChild,
            args: [SdsTableRowComponent]
        }], sdsTableHeaderRowComponent: [{
            type: ContentChild,
            args: [SdsTableHeaderRowComponent]
        }], sdsTableFooterRowComponent: [{
            type: ContentChild,
            args: [SdsTableFooterRowComponent]
        }], sdsColumnItems: [{
            type: ContentChildren,
            args: [SdsTableColumnDefComponent, { descendants: true }]
        }], matSort: [{
            type: ViewChild,
            args: [MatSort]
        }], matPaginator: [{
            type: ViewChild,
            args: [MatPaginator]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SdsTableComponent, { className: "SdsTableComponent" }); })();

class SdsTableModule {
    /** @nocollapse */ static { this.ɵfac = function SdsTableModule_Factory(t) { return new (t || SdsTableModule)(); }; }
    /** @nocollapse */ static { this.ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: SdsTableModule }); }
    /** @nocollapse */ static { this.ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ imports: [RouterModule,
            CommonModule,
            MatSortModule,
            MatTableModule,
            MatPaginatorModule,
            PaginationModule,
            IconModule,
            NgxBootstrapIconsModule.pick({ chevronUp, chevronDown })] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsTableModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SdsTableComponent,
                    SdsTableRowComponent,
                    SdsTableHeaderRowComponent,
                    SdsTableFooterRowComponent,
                    SdsTableColumnDefComponent,
                    SdsTableCellDirective,
                    SdsTableHeaderCellDirective,
                    SdsTableFooterCellDirective,
                    TableRowNavigationDirective,
                ],
                imports: [
                    RouterModule,
                    CommonModule,
                    MatSortModule,
                    MatTableModule,
                    MatPaginatorModule,
                    PaginationModule,
                    IconModule,
                    NgxBootstrapIconsModule.pick({ chevronUp, chevronDown }),
                ],
                exports: [
                    SdsTableComponent,
                    SdsTableRowComponent,
                    SdsTableHeaderRowComponent,
                    SdsTableFooterRowComponent,
                    SdsTableColumnDefComponent,
                    SdsTableCellDirective,
                    SdsTableHeaderCellDirective,
                    SdsTableFooterCellDirective,
                    TableRowNavigationDirective,
                ],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SdsTableModule, { declarations: [SdsTableComponent,
        SdsTableRowComponent,
        SdsTableHeaderRowComponent,
        SdsTableFooterRowComponent,
        SdsTableColumnDefComponent,
        SdsTableCellDirective,
        SdsTableHeaderCellDirective,
        SdsTableFooterCellDirective,
        TableRowNavigationDirective], imports: [RouterModule,
        CommonModule,
        MatSortModule,
        MatTableModule,
        MatPaginatorModule,
        PaginationModule,
        IconModule, i1$2.NgxBootstrapIconsModule], exports: [SdsTableComponent,
        SdsTableRowComponent,
        SdsTableHeaderRowComponent,
        SdsTableFooterRowComponent,
        SdsTableColumnDefComponent,
        SdsTableCellDirective,
        SdsTableHeaderCellDirective,
        SdsTableFooterCellDirective,
        TableRowNavigationDirective] }); })();

class SdsTableColumnSettings {
    constructor() {
        /**
         * Column sticks to left side of table on horizontal scroll
         */
        this.sticky = false;
    }
}

class SdsTableSettings {
}

const _c0 = ["buttonGroupTemplate"];
const _c1 = ["*"];
function SdsButtonGroupOptionComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["#content", ""]);
} }
const _c2 = (a0, a1, a2) => ({ "usa-button--outline": a0, "usa-button": a1, modular: a2 });
function SdsButtonGroupComponent_ng_container_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
function SdsButtonGroupComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "mat-button-toggle", 3, 0)(3, "div", 4);
    i0.ɵɵtemplate(4, SdsButtonGroupComponent_ng_container_1_ng_container_4_Template, 1, 0, "ng-container", 5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const option_r1 = ctx.$implicit;
    const singleToggle_r2 = i0.ɵɵreference(2);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("value", option_r1.value);
    i0.ɵɵpropertyInterpolate("aria-label", option_r1.ariaLabel);
    i0.ɵɵproperty("disableRipple", true)("checked", option_r1.checked)("disabled", option_r1.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(7, _c2, !ctx_r2.modularDashboard && !singleToggle_r2.checked, !ctx_r2.modularDashboard, ctx_r2.modularDashboard));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", option_r1.buttonGroupTemplate);
} }
const _c3 = function () { return ".mat-button-toggle .mat-pseudo-checkbox{display:none;margin-right:0!important}mat-button-toggle-group[_ngcontent-%COMP%]{overflow:visible;width:fit-content;border:none}mat-button-toggle-group[_ngcontent-%COMP%]   mat-button-toggle.sds-button-group__item[_ngcontent-%COMP%]{background-color:transparent}mat-button-toggle-group[_ngcontent-%COMP%]   mat-button-toggle.sds-button-group__item[_ngcontent-%COMP%]     .mat-button-toggle-button{background-color:transparent}mat-button-toggle-group[_ngcontent-%COMP%]   mat-button-toggle.sds-button-group__item[_ngcontent-%COMP%]     .mat-button-toggle-button .mat-button-toggle-label-content{line-height:inherit;padding:0;background-color:transparent}mat-button-toggle-group[_ngcontent-%COMP%]   mat-button-toggle.sds-button-group__item[_ngcontent-%COMP%]     .mat-button-toggle-button .mat-button-toggle-label-content .usa-button{margin-left:-2px;margin-right:-1px}mat-button-toggle-group[_ngcontent-%COMP%]   mat-button-toggle.sds-button-group__item[_ngcontent-%COMP%]     .mat-button-toggle-button .mat-button-toggle-label-content .usa-button.usa-button--outline{background-color:transparent}mat-button-toggle-group[_ngcontent-%COMP%]   mat-button-toggle.sds-button-group__item[_ngcontent-%COMP%]    :focus{outline:.25rem solid #2491ff;outline-offset:.25rem}mat-button-toggle-group[_ngcontent-%COMP%]   mat-button-toggle.sds-button-group__item[_ngcontent-%COMP%]:first-child   .usa-button[_ngcontent-%COMP%]{border-top-right-radius:0;border-bottom-right-radius:0}mat-button-toggle-group[_ngcontent-%COMP%]   mat-button-toggle.sds-button-group__item[_ngcontent-%COMP%]:last-child   .usa-button[_ngcontent-%COMP%]{border-top-left-radius:0;border-bottom-left-radius:0}mat-button-toggle-group[_ngcontent-%COMP%]   mat-button-toggle.sds-button-group__item[_ngcontent-%COMP%]:only-child   .usa-button[_ngcontent-%COMP%]{border-radius:.25rem}mat-button-toggle-group[_ngcontent-%COMP%]   mat-button-toggle.sds-button-group__item[_ngcontent-%COMP%]:not(:first-child):not(:last-child)   .usa-button[_ngcontent-%COMP%]{border-radius:0}"; };
class SdsButtonGroupOptionComponent {
    /** @nocollapse */ static { this.ɵfac = function SdsButtonGroupOptionComponent_Factory(t) { return new (t || SdsButtonGroupOptionComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: SdsButtonGroupOptionComponent, selectors: [["sds-button-group-option"]], viewQuery: function SdsButtonGroupOptionComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.buttonGroupTemplate = _t.first);
        } }, inputs: { value: "value", checked: "checked", ariaLabel: [i0.ɵɵInputFlags.None, "aria-label", "ariaLabel"], disabled: "disabled" }, ngContentSelectors: _c1, decls: 2, vars: 0, consts: [["buttonGroupTemplate", ""]], template: function SdsButtonGroupOptionComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, SdsButtonGroupOptionComponent_ng_template_0_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } }, styles: [_c3()] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsButtonGroupOptionComponent, [{
        type: Component,
        args: [{ selector: 'sds-button-group-option', template: `
    <ng-template #buttonGroupTemplate>
      <ng-content #content></ng-content>
    </ng-template>
  `, styles: ["::ng-deep .mat-button-toggle .mat-pseudo-checkbox{display:none;margin-right:0!important}mat-button-toggle-group{overflow:visible;width:fit-content;border:none}mat-button-toggle-group mat-button-toggle.sds-button-group__item{background-color:transparent}mat-button-toggle-group mat-button-toggle.sds-button-group__item ::ng-deep .mat-button-toggle-button{background-color:transparent}mat-button-toggle-group mat-button-toggle.sds-button-group__item ::ng-deep .mat-button-toggle-button .mat-button-toggle-label-content{line-height:inherit;padding:0;background-color:transparent}mat-button-toggle-group mat-button-toggle.sds-button-group__item ::ng-deep .mat-button-toggle-button .mat-button-toggle-label-content .usa-button{margin-left:-2px;margin-right:-1px}mat-button-toggle-group mat-button-toggle.sds-button-group__item ::ng-deep .mat-button-toggle-button .mat-button-toggle-label-content .usa-button.usa-button--outline{background-color:transparent}mat-button-toggle-group mat-button-toggle.sds-button-group__item ::ng-deep:focus{outline:.25rem solid #2491ff;outline-offset:.25rem}mat-button-toggle-group mat-button-toggle.sds-button-group__item:first-child .usa-button{border-top-right-radius:0;border-bottom-right-radius:0}mat-button-toggle-group mat-button-toggle.sds-button-group__item:last-child .usa-button{border-top-left-radius:0;border-bottom-left-radius:0}mat-button-toggle-group mat-button-toggle.sds-button-group__item:only-child .usa-button{border-radius:.25rem}mat-button-toggle-group mat-button-toggle.sds-button-group__item:not(:first-child):not(:last-child) .usa-button{border-radius:0}\n"] }]
    }], null, { buttonGroupTemplate: [{
            type: ViewChild,
            args: ['buttonGroupTemplate']
        }], value: [{
            type: Input
        }], checked: [{
            type: Input
        }], ariaLabel: [{
            type: Input,
            args: ['aria-label']
        }], disabled: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SdsButtonGroupOptionComponent, { className: "SdsButtonGroupOptionComponent" }); })();
class SdsButtonGroupComponent {
    constructor() {
        this.classesToApply = {};
        /**
         * 'checkbox' || 'radio'
         */
        this.mode = 'radio';
        this.modularDashboard = false;
        this.change = new EventEmitter();
    }
    ngOnInit() {
        if (this.modularDashboard) {
            this.mode = 'radio';
        }
    }
    /** @nocollapse */ static { this.ɵfac = function SdsButtonGroupComponent_Factory(t) { return new (t || SdsButtonGroupComponent)(); }; }
    /** @nocollapse */ static { this.ɵcmp = /** @pureOrBreakMyCode */ i0.ɵɵdefineComponent({ type: SdsButtonGroupComponent, selectors: [["sds-button-group"]], contentQueries: function SdsButtonGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, SdsButtonGroupOptionComponent, 4);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.buttonOptions = _t);
        } }, hostAttrs: [1, "sds-button-group--segmented"], hostVars: 2, hostBindings: function SdsButtonGroupComponent_HostBindings(rf, ctx) { if (rf & 2) {
            i0.ɵɵclassProp("sds-button-group--modular", ctx.modularDashboard);
        } }, inputs: { mode: "mode", modularDashboard: "modularDashboard" }, outputs: { change: "change" }, decls: 2, vars: 2, consts: [["singleToggle", ""], [3, "change", "multiple"], [4, "ngFor", "ngForOf"], [1, "sds-button-group__item", 3, "value", "aria-label", "disableRipple", "checked", "disabled"], [3, "ngClass"], [4, "ngTemplateOutlet"]], template: function SdsButtonGroupComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-button-toggle-group", 1);
            i0.ɵɵlistener("change", function SdsButtonGroupComponent_Template_mat_button_toggle_group_change_0_listener($event) { return ctx.change.emit($event); });
            i0.ɵɵtemplate(1, SdsButtonGroupComponent_ng_container_1_Template, 5, 11, "ng-container", 2);
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵproperty("multiple", ctx.mode === "checkbox");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.buttonOptions);
        } }, dependencies: [i1.NgClass, i1.NgForOf, i1.NgTemplateOutlet, i2$2.MatButtonToggleGroup, i2$2.MatButtonToggle], styles: [_c3()] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsButtonGroupComponent, [{
        type: Component,
        args: [{ selector: 'sds-button-group', host: {
                    class: 'sds-button-group--segmented',
                    '[class.sds-button-group--modular]': 'modularDashboard',
                }, template: "<mat-button-toggle-group [multiple]=\"mode === 'checkbox'\" (change)=\"change.emit($event)\">\n  <ng-container *ngFor=\"let option of buttonOptions\">\n    <mat-button-toggle\n      #singleToggle\n      value=\"{{ option.value }}\"\n      aria-label=\"{{ option.ariaLabel }}\"\n      class=\"sds-button-group__item\"\n      [disableRipple]=\"true\"\n      [checked]=\"option.checked\"\n      [disabled]=\"option.disabled\"\n    >\n      <div\n        [ngClass]=\"{\n          'usa-button--outline': !modularDashboard && !singleToggle.checked,\n          'usa-button': !modularDashboard,\n          modular: modularDashboard\n        }\"\n      >\n        <ng-container *ngTemplateOutlet=\"option.buttonGroupTemplate\"></ng-container>\n      </div>\n    </mat-button-toggle>\n  </ng-container>\n</mat-button-toggle-group>\n", styles: ["::ng-deep .mat-button-toggle .mat-pseudo-checkbox{display:none;margin-right:0!important}mat-button-toggle-group{overflow:visible;width:fit-content;border:none}mat-button-toggle-group mat-button-toggle.sds-button-group__item{background-color:transparent}mat-button-toggle-group mat-button-toggle.sds-button-group__item ::ng-deep .mat-button-toggle-button{background-color:transparent}mat-button-toggle-group mat-button-toggle.sds-button-group__item ::ng-deep .mat-button-toggle-button .mat-button-toggle-label-content{line-height:inherit;padding:0;background-color:transparent}mat-button-toggle-group mat-button-toggle.sds-button-group__item ::ng-deep .mat-button-toggle-button .mat-button-toggle-label-content .usa-button{margin-left:-2px;margin-right:-1px}mat-button-toggle-group mat-button-toggle.sds-button-group__item ::ng-deep .mat-button-toggle-button .mat-button-toggle-label-content .usa-button.usa-button--outline{background-color:transparent}mat-button-toggle-group mat-button-toggle.sds-button-group__item ::ng-deep:focus{outline:.25rem solid #2491ff;outline-offset:.25rem}mat-button-toggle-group mat-button-toggle.sds-button-group__item:first-child .usa-button{border-top-right-radius:0;border-bottom-right-radius:0}mat-button-toggle-group mat-button-toggle.sds-button-group__item:last-child .usa-button{border-top-left-radius:0;border-bottom-left-radius:0}mat-button-toggle-group mat-button-toggle.sds-button-group__item:only-child .usa-button{border-radius:.25rem}mat-button-toggle-group mat-button-toggle.sds-button-group__item:not(:first-child):not(:last-child) .usa-button{border-radius:0}\n"] }]
    }], null, { buttonOptions: [{
            type: ContentChildren,
            args: [SdsButtonGroupOptionComponent]
        }], mode: [{
            type: Input
        }], modularDashboard: [{
            type: Input
        }], change: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(SdsButtonGroupComponent, { className: "SdsButtonGroupComponent" }); })();

class SdsButtonGroupModule {
    /** @nocollapse */ static { this.ɵfac = function SdsButtonGroupModule_Factory(t) { return new (t || SdsButtonGroupModule)(); }; }
    /** @nocollapse */ static { this.ɵmod = /** @pureOrBreakMyCode */ i0.ɵɵdefineNgModule({ type: SdsButtonGroupModule }); }
    /** @nocollapse */ static { this.ɵinj = /** @pureOrBreakMyCode */ i0.ɵɵdefineInjector({ imports: [CommonModule, MatButtonToggleModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SdsButtonGroupModule, [{
        type: NgModule,
        args: [{
                declarations: [SdsButtonGroupComponent, SdsButtonGroupOptionComponent],
                imports: [CommonModule, MatButtonToggleModule],
                exports: [SdsButtonGroupComponent, SdsButtonGroupOptionComponent],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SdsButtonGroupModule, { declarations: [SdsButtonGroupComponent, SdsButtonGroupOptionComponent], imports: [CommonModule, MatButtonToggleModule], exports: [SdsButtonGroupComponent, SdsButtonGroupOptionComponent] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { SdsAccordionComponent, SdsAccordionContentDirective, SdsAccordionItemComponent, SdsAccordionModule, SdsAccordionTitleDirective, SdsButtonGroupComponent, SdsButtonGroupModule, SdsButtonGroupOptionComponent, SdsTableCellDirective, SdsTableColumnDefComponent, SdsTableColumnSettings, SdsTableComponent, SdsTableFooterCellDirective, SdsTableFooterRowComponent, SdsTableHeaderCellDirective, SdsTableHeaderColor, SdsTableHeaderRowComponent, SdsTableModule, SdsTableRowComponent, SdsTableSettings, TableRowNavigationDirective };
